<div class="db-anniversary-offer-banner__head">
  <p><span>5th</span>anniversary special offer</p>
</div>
<div class="db-anniversary-offer-banner__content">
  <!--<i class="db-icon db-icon-ds-close close" (click)="onClose.emit()"></i>-->
<!--  <div class="db-anniversary-offer-banner__hours-left">
    <ds-score [scoreText]="hoursLeft + countDownUnit" [score]="countDownUnit === 'd' ? scoreInHours : endDateInHours" [lineWidth]="2" [size]="'m'" [withShadow]="false"></ds-score>
  </div>-->

  <div class="db-anniversary-offer-banner__header mt35 mb30">
    <p class="mb6">Celebrate with us</p>
    <h4 class="db-anniversary-offer-banner__title">Get a 30% lifetime discount on all plans!</h4>
  </div>

  <ng-container>
    <div class="text-center">
      <button class="ds-btn-green ds-btn-l mb12" (click)="claimOffer()">
        <span>Claim Your Present</span>
      </button>

      <div class="db-anniversary-offer-banner__money-back mb25">
        Cancel Anytime
      </div>
    </div>
  </ng-container>
</div>
